import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

type PropTypes = SpaceProps &
  LayoutProps & {
    reverse?: boolean;
  };

const Actions = styled.div<PropTypes>`
  display: grid;
  grid-gap: ${tokens.space.regular};
  grid-auto-flow: column;
  width: 100%;
  justify-content: ${({ reverse }): string => (reverse ? 'start' : 'end')};

  ${space}
  ${layout}
`;

export default Actions;
